import { useState } from 'react';
import { func, string } from 'prop-types';
import Modal from '../Modal';

const DestructiveConfirmModal = ({ title, message, confirmPhrase, onConfirm, onDismiss }) => {
    const [inputValue, setInputValue] = useState('');

    const isMatch = inputValue.toLowerCase().trim() === confirmPhrase.toLowerCase().trim();

    return (
        <Modal
            size="md"
            title={title}
            header={<span className="modal-icon material-symbols-outlined ms-auto">warning</span>}
            onEscape={() => onDismiss()}
            body={(<>
                        <p>{message}</p>
                        <p className="m-top-10">
                            Escriba <strong>{confirmPhrase}</strong> para confirmar:
                        </p>
                        <input
                            type="text"
                            className="form-control"
                            placeholder={confirmPhrase}
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                            autoFocus
                        />
            </>)}
            footer={(<>
                        <button
                            className="btn back-button"
                            data-dismiss="modal"
                            onClick={() => onDismiss()}
                        >
                            Cancelar
                        </button>
                        <button
                            className={`btn ${isMatch ? 'decline-button' : 'back-button'}`}
                            data-dismiss="modal"
                            onClick={() => onConfirm()}
                            disabled={!isMatch}
                        >
                            Eliminar
                        </button>
            </>)}
            footerClassName="disp-b"
        />
    );
};

DestructiveConfirmModal.propTypes = {
    title: string.isRequired,
    message: string.isRequired,
    confirmPhrase: string.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

export default DestructiveConfirmModal;
